import React, { Component } from 'react';
import Markdown from 'markdown-to-jsx';
import { FaRobot } from 'react-icons/fa';

class AgentAssist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: [], // Stores chat messages
            newMessage: '', // Stores current input text
            loading: false, // Indicates if the message is being sent
            error: '', // Stores any errors
        };
        // Create a ref for the bottom of the messages container
        this.messagesEndRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        // Scroll to the bottom whenever messages change
        this.scrollToBottom();
    }

    scrollToBottom = () => {
        if (this.messagesEndRef.current) {
            this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    handleInputChange = (e) => {
        this.setState({ newMessage: e.target.value });
    };

    sendMessage = () => {
        const { newMessage } = this.state;

        if (newMessage.trim()) {
            this.setState({ loading: true, error: '' });
            const message = { text: newMessage, user: 'agent', timestamp: new Date().toISOString() };

            // Send the message through WebSocket
            //this.ws.send(JSON.stringify(message));

            if (this.props.data.AgentAssist.messages) {
                this.props.data.AgentAssist.messages.push(message);
            } else {
                this.props.data.AgentAssist.messages = [message];
            }
            this.props.data.AgentAssist.loading = true;
            console.log(message.text);
            this.props.data.AgentAssist.request = message.text;
            this.props.ws.send(JSON.stringify({
                route: 'chat', data: this.props.data.AgentAssist
            }));

            this.setState((prevState) => ({
                newMessage: '',
                loading: true,
            }));
        } else {
            this.setState({ error: 'Please enter a message.' });
        }
    };

    renderMessages = () => {
        const messages = this.props.data.AgentAssist.messages || [];

        return messages.map((msg, index) => (
            <div key={index} style={{ ...styles.message, ...styles[msg.user] }}>
                <div style={styles.messageText}>
                    <Markdown options={{ forceBlock: true }}>
                        {msg.text}
                    </Markdown>
                </div>
                <div style={styles.messageTimestamp}>
                    {new Date(msg.timestamp).toLocaleTimeString()}
                </div>
            </div>
        ));
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.sendMessage();
        }
    };

    render() {
        const { newMessage } = this.state;
        const error = this.props.data.AgentAssist.error;
        const loading = this.props.data.AgentAssist.loading;

        return (
            <div style={styles.chatContainer}>
                <div style={styles.chatHeader}>
                    <FaRobot style={{ ...styles.icon, fontSize: '2.5em', marginRight: '15px' }} /> {/* Larger icon with space */}
                    <h2 style={styles.headerText}>Agent Assistant</h2>
                </div>
                <div style={styles.chatMessages}>
                    {this.renderMessages()}
                    {loading && (
                        <div style={{ ...styles.message, ...styles.assistant, ...styles.breathingBubble }}>
                            <div style={styles.messageText}>...</div>
                        </div>
                    )}
                    {/* Empty div to mark the end of the messages */}
                    <div ref={this.messagesEndRef} />
                </div>
                <div style={styles.chatInput}>
                    <input
                        type="text"
                        value={newMessage}
                        onChange={this.handleInputChange}
                        onKeyDown={this.handleKeyDown}
                        placeholder="Type your message..."
                        disabled={loading}
                        style={styles.input}
                    />
                    <button
                        onClick={this.sendMessage}
                        disabled={loading}
                        style={loading ? { ...styles.buttonDisabled, ...styles.breathing } : styles.button}
                    >
                        Send
                    </button>
                </div>
                {error && <div style={styles.chatError}>{error}</div>}
            </div>
        );
    }
}

const styles = {
    chatContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '80vh', // Taller height
        width: '90vw', // Wider width
        maxWidth: '1200px', // Limits max width
        margin: '10px auto', // Reduced margin around container
        border: '1px solid #ccc',
        borderRadius: '5px',
        overflow: 'hidden',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
    },
    chatHeader: {
        backgroundColor: '#2A6AA9',
        color: '#fff',
        padding: '10px 20px', // Adjusted padding for a better look
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '1.5em',
    },
    chatMessages: {
        flex: 1,
        padding: '5px 10px', // Less padding inside chat messages
        overflowY: 'auto',
        background: '#f1f1f1',
        maxHeight: '70vh', // Increased max height to accommodate taller container
    },
    message: {
        margin: '5px 0', // Reduced margin between messages
        padding: '8px 10px', // Adjusted padding for messages
        borderRadius: '5px',
        maxWidth: '70%',
    },
    agent: {
        backgroundColor: '#97c13d',
        alignSelf: 'flex-end',
    },
    assistant: {
        backgroundColor: '#fff',
        alignSelf: 'flex-start', // Align the assistant bubble to the start
        marginLeft: 'auto', // Push the assistant bubble to the right
    },
    messageText: {
        fontSize: '1em',
    },
    messageTimestamp: {
        fontSize: '0.8em',
        color: '#888',
        marginTop: '5px',
        textAlign: 'right',
    },
    chatInput: {
        display: 'flex',
        padding: '5px 10px', // Less padding around input area
        backgroundColor: '#eee',
    },
    input: {
        flex: 1,
        padding: '8px 10px', // Adjusted padding for input field
        borderRadius: '5px',
        border: '1px solid #ccc',
        marginRight: '10px',
    },
    button: {
        padding: '8px 15px',
        backgroundColor: '#2A6AA9',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
    },
    buttonDisabled: {
        padding: '8px 15px',
        backgroundColor: '#ccc',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'not-allowed',
    },
    chatError: {
        color: 'red',
        padding: '5px 10px',
        textAlign: 'center',
    },
    // New styles for breathing animation
    breathing: {
        animation: 'breathing 2s ease-in-out infinite',
    },
    breathingBubble: {
        animation: 'breathing 2s ease-in-out infinite',
    },
};

// Breathing keyframe animation
const keyframes = `
@keyframes breathing {
    0% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 0.5;
        transform: scale(1.05);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}`;

// Adding keyframes to document
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = keyframes;
document.head.appendChild(styleSheet);

const icon = "menuConverse";
const roles = ["View", "Add", "Edit", "Delete"];
export { AgentAssist, icon, roles };